export const environment = {
  production: true,
  license: 'vibe',
  sentry: {
    dsn: 'https://9bd21ca3be29452eab1ef763801fb46f@o1003497.ingest.sentry.io/5963962',
    environment: 'production',
    tracesSampleRate: 0.1,
  },
  googleAnalytics: 'G-WM26WLL6KZ',
  allowSubmissionsToViewOtherSubmissions: true,
  numberOfAcceptedOrganisationCallsInMenu: 2,
  collectiveRightsManagementEnabled: true,
  config: {
    production: true,
    authUrl: 'https://auth.vi.be',
    authSocialEnabled: true,
    backendHost: 'https://vi.be',
    backendUrl: '/platform/api',
    redirectUri: 'https://vi.be/platform/auth/callback',
    cognitoPool: {
      UserPoolId: 'eu-west-1_IL1uOeiz1',
      ClientId: '6jka3idn86svb6hbr52o1mpac1',
    },
    contentUrl: 'https://vi.be/api/platform',
    cookieFirstKey: 'vi.be-79c3d2c5-da63-4de6-97df-1253da0fc22c',
    recaptchaSiteKey: '6LcXHD0rAAAAAPBRIbk_ju5SsX7aVwRz3YECJh7g',
  },
};
